import React from 'react'
import ResourceTable from 'teacher/components/resourceTable'
import './index.styl'

const tools = ['viewer', 'multi-touch']

export default function Resources () {
    return (
    <div className="resources">
      <ResourceTable kind="tools" resources={tools} />
    </div>)
}
